const actions = {
  setOptionsTarget({ commit }, target) {
    commit("setOptionsTarget", target);
  },
  setCategory({ commit }, category) {
    commit("setCategory", category);
  },
  setPurity({ commit }, purity) {
    commit("setCategory", purity);
  },
};

export default actions;
